module.exports = __webpack_public_path__ + "media/images/sports_icons/gym@2x-707faa96792c8845852e7bd600269ef1.png";